module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message.body))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617addab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MessageItem.vue
// module id = 1272
// module chunks = 1